import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ReportIdSchema, RunIdSchema } from "../primitives/ids.js";
/** idempotency-record.v1.0 — create-run / enqueue / export / report dedupe */
export const IdempotencyScopeSchema = z.enum([
    "CREATE_RUN",
    "ENQUEUE_JOB",
    "EXPORT_RUN",
    "REPORT_GENERATION",
]);
export const IdempotencyRecordV1Schema = z
    .object({
    schemaVersion: z.literal("idempotency-record.v1.0"),
    scope: IdempotencyScopeSchema,
    idempotencyKey: z.string().min(1).max(512),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    resolvedRunId: RunIdSchema.optional(),
    resolvedReportId: ReportIdSchema.optional(),
    createdAt: z.string().datetime(),
})
    .strict()
    .superRefine((data, ctx) => {
    if (data.scope === "REPORT_GENERATION") {
        if (!data.resolvedReportId) {
            ctx.addIssue({
                code: "custom",
                message: "REPORT_GENERATION requires resolvedReportId",
                path: ["resolvedReportId"],
            });
        }
        return;
    }
    if (!data.resolvedRunId) {
        ctx.addIssue({
            code: "custom",
            message: `${data.scope} requires resolvedRunId`,
            path: ["resolvedRunId"],
        });
    }
});
//# sourceMappingURL=idempotency-record.js.map